// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"651":"9c054988","718":"11d31e6c","812":"c00a20ba"}[chunkId] + ".css";
};